/**
 * @generated SignedSource<<e0657ddb1a7345d42adacc584f2e2a83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type confluenceTemplateCollectionDetailsRelayPageQuery$variables = {
  locale: string;
  relatedCollectionUrlSlugs: ReadonlyArray<string>;
  urlSlug: string;
};
export type confluenceTemplateCollectionDetailsRelayPageQuery$data = {
  readonly collections: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly howToUseThisCollection: {
          readonly " $fragmentSpreads": FragmentRefs<"collectionGuideSectionRelayFragment">;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"collectionAboutSectionRelayFragment" | "collectionHeaderSectionRelayFragment">;
      };
    }>;
  };
  readonly relatedCollections: {
    readonly " $fragmentSpreads": FragmentRefs<"collectionRelatedSectionRelayFragment">;
  };
};
export type confluenceTemplateCollectionDetailsRelayPageQuery = {
  response: confluenceTemplateCollectionDetailsRelayPageQuery$data;
  variables: confluenceTemplateCollectionDetailsRelayPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relatedCollectionUrlSlugs"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlSlug"
},
v3 = {
  "kind": "Literal",
  "name": "fieldNamed",
  "value": "urlSlug"
},
v4 = {
  "items": [
    {
      "kind": "Variable",
      "name": "withLocales.0",
      "variableName": "locale"
    }
  ],
  "kind": "ListValue",
  "name": "withLocales"
},
v5 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          },
          {
            "fields": [
              (v3/*: any*/),
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "havingValues.0",
                    "variableName": "urlSlug"
                  }
                ],
                "kind": "ListValue",
                "name": "havingValues"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          },
          (v4/*: any*/)
        ],
        "kind": "ObjectValue",
        "name": "queries"
      }
    ],
    "kind": "ObjectValue",
    "name": "search"
  }
],
v6 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 2
          },
          {
            "fields": [
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "havingValues",
                "variableName": "relatedCollectionUrlSlugs"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          },
          (v4/*: any*/)
        ],
        "kind": "ObjectValue",
        "name": "queries"
      }
    ],
    "kind": "ObjectValue",
    "name": "search"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = [
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "confluenceTemplateCollectionDetailsRelayPageQuery",
    "selections": [
      {
        "alias": "collections",
        "args": (v5/*: any*/),
        "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
        "kind": "LinkedField",
        "name": "templateCollections",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateCollectionResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplateCollection",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "collectionHeaderSectionRelayFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "collectionAboutSectionRelayFragment"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateCollectionGuide",
                    "kind": "LinkedField",
                    "name": "howToUseThisCollection",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "collectionGuideSectionRelayFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "relatedCollections",
        "args": (v6/*: any*/),
        "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
        "kind": "LinkedField",
        "name": "templateCollections",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "collectionRelatedSectionRelayFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "confluenceTemplateCollectionDetailsRelayPageQuery",
    "selections": [
      {
        "alias": "collections",
        "args": (v5/*: any*/),
        "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
        "kind": "LinkedField",
        "name": "templateCollections",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateCollectionResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplateCollection",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oneLinerHeadline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aboutThisCollectionHeader",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aboutThisCollection",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateImageAsset",
                    "kind": "LinkedField",
                    "name": "aboutThisCollectionImage",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": "name",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateCollectionGuide",
                    "kind": "LinkedField",
                    "name": "howToUseThisCollection",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentPlatformTemplateCollectionStep",
                        "kind": "LinkedField",
                        "name": "collectionSteps",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stepSubheading",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stepDescription",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformTemplate",
                            "kind": "LinkedField",
                            "name": "relatedTemplate",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "templateId",
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pluginModuleKey",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previewBlurb",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentPlatformTaxonomyTemplateType",
                                "kind": "LinkedField",
                                "name": "templateType",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "templateTypeName",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "contributor",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v11/*: any*/),
                                    "type": "ContentPlatformOrganization",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentPlatformOrganization",
                                        "kind": "LinkedField",
                                        "name": "organization",
                                        "plural": false,
                                        "selections": (v11/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ContentPlatformAuthor",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "relatedCollections",
        "args": (v6/*: any*/),
        "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
        "kind": "LinkedField",
        "name": "templateCollections",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateCollectionResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplateCollection",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionId",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateImageAsset",
                    "kind": "LinkedField",
                    "name": "collectionIcon",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateCollectionGuide",
                    "kind": "LinkedField",
                    "name": "howToUseThisCollection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentPlatformTemplateCollectionStep",
                        "kind": "LinkedField",
                        "name": "collectionSteps",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2b396062365f32e3132c45d8b5e09dfd",
    "id": null,
    "metadata": {},
    "name": "confluenceTemplateCollectionDetailsRelayPageQuery",
    "operationKind": "query",
    "text": "query confluenceTemplateCollectionDetailsRelayPageQuery(\n  $locale: String!\n  $urlSlug: String!\n  $relatedCollectionUrlSlugs: [String!]!\n) {\n  collections: templateCollections(search: {queries: {first: 1, withLocales: [$locale], where: {fieldNamed: \"urlSlug\", havingValues: [$urlSlug]}}}) {\n    edges {\n      node {\n        ...collectionHeaderSectionRelayFragment\n        ...collectionAboutSectionRelayFragment\n        howToUseThisCollection {\n          ...collectionGuideSectionRelayFragment\n        }\n      }\n    }\n  }\n  relatedCollections: templateCollections(search: {queries: {first: 2, withLocales: [$locale], where: {fieldNamed: \"urlSlug\", havingValues: $relatedCollectionUrlSlugs}}}) {\n    ...collectionRelatedSectionRelayFragment\n  }\n}\n\nfragment collectionAboutSectionRelayFragment on ContentPlatformTemplateCollection {\n  name\n  aboutThisCollectionHeader\n  aboutThisCollection\n  aboutThisCollectionImage {\n    url\n    name: title\n  }\n}\n\nfragment collectionCardRelayFragment on ContentPlatformTemplateCollection {\n  collectionId\n  name\n  urlSlug\n  collectionIcon {\n    url\n  }\n  howToUseThisCollection {\n    collectionSteps {\n      __typename\n    }\n  }\n}\n\nfragment collectionGuideSectionRelayFragment on ContentPlatformTemplateCollectionGuide {\n  name\n  collectionSteps {\n    name\n    stepSubheading\n    stepDescription\n    relatedTemplate {\n      urlSlug\n      ...templateCardRelayFragment\n    }\n  }\n}\n\nfragment collectionHeaderSectionRelayFragment on ContentPlatformTemplateCollection {\n  name\n  oneLinerHeadline\n}\n\nfragment collectionRelatedSectionRelayFragment on ContentPlatformTemplateCollectionContentSearchConnection {\n  edges {\n    node {\n      collectionId\n      ...collectionCardRelayFragment\n    }\n  }\n}\n\nfragment templateCardRelayFragment on ContentPlatformTemplate {\n  templateId\n  name\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateType {\n    id\n    templateTypeName\n  }\n  contributor {\n    __typename\n    ... on ContentPlatformOrganization {\n      name\n    }\n    ... on ContentPlatformAuthor {\n      organization {\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "732359a6944a3fa6a17b0037c5a47b87";

export default node;
